import React, { useEffect, useState } from "react"
import { CustomButton, SectionHeader } from "../GlobalComponents/CommonComponents"
import { FormField } from "../GlobalComponents/Fields"
import "./index.css"
// import Textarea from './TextArea';
import Textarea from "@mui/joy/Textarea"
import { Box, Typography } from "@mui/material"
import FileUpload, { FileModal } from "./FileUpload"
import { getFormattedDate } from "../../utils/Helpers"
import BasicModal from "../GlobalComponents/BasicModal"
import { relationShipOptions } from "../../utils/constants"


const InvoicesSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal,
    // onCloseModal,

  } = props.data
  const [selectedFile, setSelectedFile] = useState(null)

  // useEffect(() => {
  //   if (!formData.termsConditions) {
  //     handleChange({ target: { name: "termsConditions", value: options[1]?.value } })
  //   } else if (!formData.permissionToStoreData) {
  //     handleChange({
  //       target: { name: "permissionToStoreData", value: options[1]?.value },
  //     })
  //   }
  // }, [formData])

  function onCloseModal() {
    setSelectedFile("")
  }

  let modalData = {}
  if (selectedFile) {
    modalData = {
      // ...modalData,
      onClose: onCloseModal,
      title: "Invoice",
      // title: "Uploaded Image",
      showSecondButton: false,
      show: true,
      modalStyles: {
        width: "60%",
        height: "90%",
        maxWidth: "900px",
        maxHeight: "600px",
      },
      modalStyleClassName: "file-upload-modal",
      showFooter: false,
    }
  }

  function onClickView(file) {
    setSelectedFile(file)
  }

  console.log("formDataformData456", formData)

  return (
    <Box
      style={{
        border: "0px solid blue",
        flex: 1,
        width: "100%",
        borderRadius: "5px",
      }}
    >
      <SectionHeader title="List of Invoices" />
      <Box className="patient-form-fields-container">
        {
          (!(formData?.invoiceDetails) || formData?.invoiceDetails?.length === 0) ?
            <p className="center-container">Empty Invoices</p>
            :
            formData?.invoiceDetails?.map((invoice, index) => {
              return <Box className="space-between">
                <p>Invoice Amount: £{invoice?.amount}</p>
                <Typography>{getFormattedDate(invoice?.createdAt)} </Typography>
                <CustomButton
                  sx={{ marginLeft: "30px" }}
                  component="span"
                  text="View Invoice"
                  onClick={() => onClickView(invoice)}
                />
              </Box>
            })
        }

      </Box>


      {modalData.show && (
        <FileModal
          url={selectedFile.url}
          fileType="pdf"
          modalData={modalData}
        />
      )}

      {/* {modalData.show && (
        <BasicModal {...modalData}>

          <div className="modal-files-container">
            <label style={{color: "white"}}>12 {selectedFile.url}</label>
            {selectedFile.fileType === "image" ? (
              <img
                src={selectedFile.url}
                className="modal-image" // Use the CSS class for images
              />
            ) : selectedFile.fileType === "pdf" ? (
              <embed
                src={selectedFile.url}
                type="application/pdf"
                className="modal-pdf" // Use the CSS class for PDFs
              />
            ) : null}
          </div>
        </BasicModal>
      )} */}
    </Box>
  )
}



const NextOfKinDetailsSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  // <CustomAccordion title="Next Of Kin Details">
  return (
    <Box style={{ flexGrow: 1 }}>
      <SectionHeader title="Next of Kin Details" />
      <Box className="patient-form-fields-container">
        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Contact Name"
          name="contactName"
          value={formData.contactName}
          onChange={handleChange}
          placeholder="Enter the contact name"
        />

        <FormField
          deattach={true}
          labelClassName="patient-form-label"
          label="Telephone"
          name="contactTelephone"
          value={formData.contactTelephone}
          onChange={handleChange}
          isNumberOnly={true}
          placeholder="Enter the contact telephone number"
        />

        <FormField
          deattach={true}
          type="dropdown"
          label="Relationship"
          labelClassName="patient-form-label"

          name="relationShip"
          value={formData.relationShip}
          options={relationShipOptions}
          onChange={handleChange}
          placeholder="Relationship"
          required={true}
        />

        {/* </CustomAccordion> */}
      </Box>
    </Box>
  )
}

const CommentsSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  const calculateRows = () => {
    const lines = formData?.comments?.split("\n").length
    const baseRows = 3 // Minimum rows for the textarea
    if (lines > 5) return 5
    return lines // Ensure that the textarea doesn't shrink below baseRows
  }

  return (
    <Box
      style={{
        border: "0px solid blue",
        // flex: 1,
        width: "100%",
      }}
    >
      <SectionHeader title="Comments" />
      <Box className="patient-form-fields-container">
        {/* <CustomAccordion title="Comments"> */}
        <Textarea
          value={formData.comments}
          minRows={2}
          maxRows={5}
          placeholder="Comments"
          name="comments"
          onChange={handleChange}
        />
        {/* </CustomAccordion> */}
      </Box>
    </Box>
  )
}

const FileUploadSection = (props) => {
  const { formData, handleChange, options, activeModal, setActiveModal } = props.data

  return (
    <Box>
      {/* <CustomAccordion title="Upload Images"> */}
      <SectionHeader title="Patient Images" />
      <Box className="patient-form-fields-container">
        <FileUpload {...props} />
      </Box>
      {/* </CustomAccordion> */}
    </Box>
  )
}


export {
  CommentsSection,
  FileUploadSection, InvoicesSection,
  NextOfKinDetailsSection
}

